<template>
  <div class="headFixed freshStatus">
    <HeadNav title="热泵状态"></HeadNav>
    <router-link :to="'/equipment'"><p class="freshHome">主页</p></router-link>

    <div v-if="vip">
      <!-- 会员 -->
      <div v-if="pageNum == 1">
        <p class="freshTitle">1#热泵</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                运行状态
                <span class="right">
									<span class="black">
										{{
                      eqInfo && eqInfo.airVentilator.runningStatusHeatPump1
                          ? eqInfo.airVentilator.runningStatusHeatPump1 === '1'
                              ? '启动中'
                              : eqInfo.airVentilator.runningStatusHeatPump1 === '2'
                                  ? '运行中'
                                  : eqInfo.airVentilator.runningStatusHeatPump1 === '3'
                                      ? '停机中'
                                      : eqInfo.airVentilator.runningStatusHeatPump1 === '4'
                                          ? '严重故障'
                                          : eqInfo.airVentilator.runningStatusHeatPump1 === '5'
                                              ? '防冻'
                                              : '待机'
                          : '待机'
                    }}
									</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                工作模式
                <span class="right">
									<span class="black" v-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump1 === '1'">制冷</span>
									<span class="black" v-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump1 === '2'">制热</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                制冷温度设置
                <span class="right"
                      v-if="eqInfo && (eqInfo.airVentilator.heatPumpCoolingTemperatureSetting || eqInfo.airVentilator.heatPumpCoolingTemperatureSetting === '0')">
									<span class="black">{{ eqInfo.airVentilator.heatPumpCoolingTemperatureSetting }}</span>
									℃
								</span>
                <span class="right" v-else><span class="black">—</span></span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                制热温度设置
                <span class="right" v-if="eqInfo">
									<span class="black">{{ eqInfo.airVentilator.heatPumpHeatingTemperatureSetting }}</span>
									℃
								</span>
                <span class="right" v-else><span class="black">—</span></span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                出水温度
                <span class="right">
									<span class="black">{{
                      eqInfo && eqInfo.airVentilator.heatPumpOutletTemperature ? eqInfo.airVentilator.heatPumpOutletTemperature : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                回水温度
                <span class="right">
									<span class="black">{{
                      eqInfo && eqInfo.airVentilator.heatPumpReturnTemperature ? eqInfo.airVentilator.heatPumpReturnTemperature : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="eqInfo && eqInfo.airVentilator.heatPumpCount === '2'">
          <p class="freshTitle">2#热泵</p>

          <div class="list list_normal list_no_arrow list_info">
            <div class="item">
              <div class="clear">
                <p>
                  运行状态
                  <span class="right">
										<span class="black">
											{{
                        eqInfo && eqInfo.airVentilator.workingModeHeatPump2
                            ? eqInfo.airVentilator.workingModeHeatPump2 === '1'
                                ? '启动中'
                                : eqInfo.airVentilator.workingModeHeatPump2 === '2'
                                    ? '运行中'
                                    : eqInfo.airVentilator.workingModeHeatPump2 === '3'
                                        ? '停机中'
                                        : eqInfo.airVentilator.workingModeHeatPump2 === '4'
                                            ? '严重故障'
                                            : eqInfo.airVentilator.workingModeHeatPump2 === '5'
                                                ? '防冻'
                                                : '待机'
                            : '待机'
                      }}
										</span>
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  工作模式
                  <span class="right">
										<span class="black" v-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump2 === '1'">制冷</span>
										<span class="black"
                          v-else-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump2 === '2'">制热</span>
										<span class="black" v-else>未知</span>
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  制冷温度设置
                  <span class="right">
										<span class="black" v-if="eqInfo">{{
                        eqInfo.airVentilator.secondaryHeatPumpCoolingTemperatureSetting ? eqInfo.airVentilator.secondaryHeatPumpCoolingTemperatureSetting : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  制热温度设置
                  <span class="right">
										<span class="black" v-if="eqInfo">{{
                        eqInfo.airVentilator.secondaryHeatPumpHeatingTemperatureSetting ? eqInfo.airVentilator.secondaryHeatPumpHeatingTemperatureSetting : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  出水温度
                  <span class="right">
										<span class="black">{{
                        eqInfo && eqInfo.airVentilator.secondaryHeatPumpOutletTemperature ? eqInfo.airVentilator.secondaryHeatPumpOutletTemperature : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  回水温度
                  <span class="right">
										<span class="black">{{
                        eqInfo && eqInfo.airVentilator.secondaryHeatPumpReturnTemperature ? eqInfo.airVentilator.secondaryHeatPumpReturnTemperature : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pageNum == 2">
        <p class="freshTitle">1#热泵故障</p>
        <p class="degreeBox">
          故障程度:
          <span class="degreeA">1级</span>
          <span class="degreeB">2级</span>
          <span class="degreeC">3级</span>
        </p>
        <div class="list list_normal list_no_arrow list_info" v-if="rebeng.length != 0">
          <div class="item" v-for="(item, index) of rebeng" :key="index">
            <div class="clear">
              <p :class="item.type">
                {{ item.title }}
                <span class="right">
									<span :class="item.type">{{ item.time }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
        <div class="list list_normal list_no_arrow list_info" v-else>
          <div class="item">
            <div class="clear"><p>暂无故障</p></div>
          </div>
        </div>
      </div>
      <div v-if="pageNum == 3">
        <p class="freshTitle">2#热泵故障</p>
        <p class="degreeBox">
          故障程度:
          <span class="degreeA">1级</span>
          <span class="degreeB">2级</span>
          <span class="degreeC">3级</span>
        </p>
        <div class="list list_normal list_no_arrow list_info" v-if="rebeng2.length != 0">
          <div class="item" v-for="(item, index) of rebeng2" :key="index">
            <div class="clear">
              <p :class="item.type">
                {{ item.title }}
                <span class="right">
									<span :class="item.type">{{ item.time }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
        <div class="list list_normal list_no_arrow list_info" v-else>
          <div class="item">
            <div class="clear"><p>暂无故障</p></div>
          </div>
        </div>
      </div>
      <div class="page" v-if="eqInfo && eqInfo.airVentilator.heatPumpCount === '2'">
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum > 1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum < 3">下一页</div>
      </div>
      <div class="page" v-else>
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum > 1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum < 2">下一页</div>
      </div>
    </div>
    <div v-else>
      <!-- 非会员 -->
      <div v-if="pageNum == 1">
        <p class="freshTitle">1#热泵</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                运行状态
                <span class="right">
									<span class="black">
										{{
                      eqInfo && eqInfo.airVentilator.runningStatusHeatPump1
                          ? eqInfo.airVentilator.runningStatusHeatPump1 === '1'
                              ? '启动中'
                              : eqInfo.airVentilator.runningStatusHeatPump1 === '2'
                                  ? '运行中'
                                  : eqInfo.airVentilator.runningStatusHeatPump1 === '3'
                                      ? '停机中'
                                      : eqInfo.airVentilator.runningStatusHeatPump1 === '4'
                                          ? '严重故障'
                                          : eqInfo.airVentilator.runningStatusHeatPump1 === '5'
                                              ? '防冻'
                                              : '待机'
                          : '待机'
                    }}
									</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                工作模式
                <span class="right">
									<span class="black" v-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump1 === '1'">制冷</span>
									<span class="black"
                        v-else-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump1 === '2'">制热</span>
									<span class="black" v-else>未知</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                出水温度
                <span class="right">
									<span class="black">{{
                      eqInfo && eqInfo.airVentilator.heatPumpOutletTemperature ? eqInfo.airVentilator.heatPumpOutletTemperature : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                回水温度
                <span class="right">
									<span class="black">{{
                      eqInfo && eqInfo.airVentilator.heatPumpReturnTemperature ? eqInfo.airVentilator.heatPumpReturnTemperature : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="eqInfo && eqInfo.airVentilator.heatPumpCount === '2'">
          <p class="freshTitle">2#热泵</p>
          <div class="list list_normal list_no_arrow list_info">
            <div class="item">
              <div class="clear">
                <p>
                  运行状态
                  <span class="right">
										<span class="black">
											{{
                        eqInfo && eqInfo.airVentilator.runningStatusHeatPump1
                            ? eqInfo.airVentilator.runningStatusHeatPump1 === '1'
                                ? '启动中'
                                : eqInfo.airVentilator.runningStatusHeatPump1 === '2'
                                    ? '运行中'
                                    : eqInfo.airVentilator.runningStatusHeatPump1 === '3'
                                        ? '停机中'
                                        : eqInfo.airVentilator.runningStatusHeatPump1 === '4'
                                            ? '严重故障'
                                            : eqInfo.airVentilator.runningStatusHeatPump1 === '5'
                                                ? '防冻'
                                                : '待机'
                            : '待机'
                      }}
										</span>
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  工作模式
                  <span class="right">
										<span class="black" v-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump2 === '1'">制冷</span>
										<span class="black"
                          v-else-if="eqInfo && eqInfo.airVentilator.workingModeHeatPump2 === '2'">制热</span>
										<span class="black" v-else>未知</span>
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  出水温度
                  <span class="right">
										<span class="black">{{
                        eqInfo && eqInfo.airVentilator.secondaryHeatPumpOutletTemperature ? eqInfo.airVentilator.secondaryHeatPumpOutletTemperature : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
            <div class="item">
              <div class="clear">
                <p>
                  回水温度
                  <span class="right">
										<span class="black">{{
                        eqInfo && eqInfo.airVentilator.secondaryHeatPumpReturnTemperature ? eqInfo.airVentilator.secondaryHeatPumpReturnTemperature : 0
                      }}</span>
										℃
									</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pageNum == 2">
        <p class="freshTitle">1#热泵故障</p>
        <p class="degreeBox">
          故障程度:
          <span class="degreeA">1级</span>
          <span class="degreeB">2级</span>
          <span class="degreeC">3级</span>
        </p>

        <div class="list list_normal list_no_arrow list_info" v-if="rebeng.length != 0">
          <div class="item" v-for="(item, index) of rebeng" :key="index">
            <div class="clear">
              <p :class="item.type">
                {{ item.title }}
                <span class="right">
									<span :class="item.type">{{ item.time }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
        <div class="list list_normal list_no_arrow list_info" v-else>
          <div class="item">
            <div class="clear"><p>暂无故障</p></div>
          </div>
        </div>
      </div>
      <div v-if="pageNum == 3">
        <p class="freshTitle">2#热泵故障</p>
        <p class="degreeBox">
          故障程度:
          <span class="degreeA">1级</span>
          <span class="degreeB">2级</span>
          <span class="degreeC">3级</span>
        </p>
        <div class="list list_normal list_no_arrow list_info" v-if="rebeng2.length != 0">
          <div class="item" v-for="(item, index) of rebeng2" :key="index">
            <div class="clear">
              <p>
                {{ item.title }}
                <span class="right">
									<span :class="item.type">{{ item.time }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
        <div class="list list_normal list_no_arrow list_info" v-else>
          <div class="item">
            <div class="clear"><p>暂无故障</p></div>
          </div>
        </div>
      </div>

      <div class="page" v-if="eqInfo && eqInfo.airVentilator.heatPumpCount === '2'">
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum > 1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum < 3">下一页</div>
      </div>
      <div class="page" v-else>
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum > 1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum < 2">下一页</div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadNav from '../../headNav/headNav';
import {b64utoutf8} from "jsrsasign";

export default {
  name: 'info',
  data() {
    return {
      vip: null,
      rebeng: [],
      rebeng2: [],
      eqInfo: null,
      socket: '',
      pageNum: 1
    };
  },
  components: {
    HeadNav: HeadNav
  },
  mounted() {
    this.readWaterTemerature();
    this.firstRequest = true;
    // this.getFreshEquipmentDetail();
    // this.getFaultList();
    this.vips();
  },

  beforeDestroy() {
    // this.socketclose();
  },
  methods: {
    vips() {
      let token = localStorage.getItem('token');
      // 拆分JWT令牌
      const parts = token.split('.');

      // 获取JWT payload（部分1）
      const payload = parts[1];

      // 将base64编码的payload解码为UTF-8字符串
      const decodedPayload = b64utoutf8(payload);

      // 解析JSON格式的payload
      const parsedPayload = JSON.parse(decodedPayload);
      this.vip = parsedPayload['vip'];
    },
    getFaultList() {
      let that = this;
      let arr = [];
      arr.push('equipmentId=' + this.$route.params.id);
      let str = arr.join('&');
      this.Api.faultList(str, function (msg) {
        if (msg.code === 200) {
          let data = msg.body.results;
          let item = [];
          let item2 = [];
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            let title = data[i].alarmDetail.substring(0, 3);
            if (title == '热泵1' && data[i].status != 2) {
              obj.title = data[i].alarmDetail;
              obj.time = data[i].alarmTime;
              switch (data[i].type) {
                case 1:
                  obj.type = 'degreeA';
                  break;
                case 2:
                  obj.type = 'degreeB';
                  break;
                case 3:
                  obj.type = 'degreeC';
                  break;
                default:
                  obj.type = 'degreeA';
              }
              item.push(obj);
            } else if (title == '热泵2' && data[i].status != 2) {
              obj.title = data[i].alarmDetail;
              obj.time = data[i].alarmTime;
              switch (data[i].type) {
                case 1:
                  obj.type = 'degreeA';
                  break;
                case 2:
                  obj.type = 'degreeB';
                  break;
                case 3:
                  obj.type = 'degreeC';
                  break;
                default:
                  obj.type = 'degreeA';
              }
              item2.push(obj);
            } else {
            }
          }
          that.rebeng = item;
          that.rebeng2 = item2;
        }
      });
    },
    readWaterTemerature() {
      let str = 'id=' + this.getId();
      this.Api.eqDetail(this.getId(), msg => {
        if (msg.code === 200) {
          this.eqInfo = msg.data;
          //初始化websocket
          if (typeof WebSocket === 'undefined') {
            alert('您的浏览器不支持socket');
          } else {
            // 实例化socket
            this.socket = this.$store.state.websocket
            if (!this.socket) {
              this.socket = new WebSocket(this.$websocketUrl + this.eqInfo.iotDeviceId);
            }
            // 监听socket连接
            this.socket.onopen = this.socketopen;
            // 监听socket错误信息
            this.socket.onerror = this.socketerror;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
            // 关闭socket消息
            this.socket.onclose = this.socketclose;
            this.$store.commit('setWebSocket', this.socket);
          }
        }
      });
    },
    getId() {
      return this.$route.params.id;
    },
    socketopen: function () {
      console.log('socket连接成功');
    },
    socketerror: function () {
      console.log('连接错误');
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // 使用 Vue.$set 确保触发响应性更新
          this.$set(this.eqInfo.airVentilator, key, data[key]);
        }
      }
    },
    socketclose: function () {
      console.log('socket已经关闭');
      this.socket.close();
    },
    getFreshEquipmentDetail() {
      let id = this.getId();
      this.Api.freshEquipmentDetail('equipmentId=' + id, msg => {
        if (msg.body) {
          this.eqInfo = msg.body;
        }
      });
    },
    goPrev() {
      let pageNum = this.pageNum;
      pageNum--;
      if (pageNum <= 1) {
        pageNum = 1;
      }
      this.pageNum = pageNum;
    },
    goNext() {
      let pageNum = this.pageNum;
      pageNum++;
      this.pageNum = pageNum;
    }
  }
};
</script>
<style scoped>
@import url('../../../assets/list.css');

.title-bg {
  background-color: #eee;
}

.degreeBox {
  text-align: right;
  padding: 0px 5px 5px;
}

.degreeA {
  color: green !important;
}

.degreeB {
  color: blue !important;
}

.degreeC {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/freshAir/status/status5.vue